function staticPage(file) {
  return { type: "static", file };
}

function staticRange(from, to) {
  const out = [];
  for (let i = from; i <= to; i += 1) {
    out.push(staticPage(`P${i}`));
  }
  return out;
}

/**
 * GEC/KBT: Head terms (pdfData) after P10, then P12–P13 (LICENSE FEE slide removed from PDF).
 * SW: P1–P12, head terms (dynamic), P14–P15.
 */
export const PROPOSAL_TEMPLATE_SEQUENCES = {
  gec: [
    ...staticRange(1, 10),
    { type: "dynamic", id: "headTerms" },
    ...staticRange(12, 13),
  ],
  kbt: [
    ...staticRange(1, 10),
    { type: "dynamic", id: "headTerms" },
    ...staticRange(12, 13),
  ],
  sw: [
    ...staticRange(1, 12),
    { type: "dynamic", id: "headTerms" },
    ...staticRange(14, 15),
  ],
};

export function getSequenceForTemplateKey(key) {
  if (!key) return null;
  return PROPOSAL_TEMPLATE_SEQUENCES[key] || null;
}
